import { useEffect, useRef } from 'react';
import {
  ANALYTICS_EVENT_TYPING_INDICATOR_SHOWN,
  pushToGTMDataLayer,
} from 'Utils/analytics';

/**
 * Fires `typing_indicator_shown` when the typing indicator becomes visible
 * to the recipient. Does not re-fire while it stays visible (e.g. a second
 * person starts typing).
 *
 * Expects a fresh mount per conversation (e.g. `key={conversationId}`).
 */
export const useTypingIndicatorAnalytics = (
  conversationId: string,
  isVisible: boolean
): void => {
  const wasVisibleRef = useRef(false);

  useEffect(() => {
    if (!isVisible) {
      wasVisibleRef.current = false;
      return;
    }

    if (wasVisibleRef.current) {
      return;
    }

    wasVisibleRef.current = true;
    pushToGTMDataLayer(ANALYTICS_EVENT_TYPING_INDICATOR_SHOWN, {
      conversationId,
    });
  }, [conversationId, isVisible]);
};
